import {
  AdequacyCriticality,
  MarketAlternative
} from "@app/projects/network-assessment/provider-hub/interfaces";
import ServiceBase from "@app/shared/serviceBase";

export default class ProviderHubService extends ServiceBase {
  private readonly endpoint = "provider-criticality";
  /**
    * @param projectRunConfigurationId integer representing the project run configuration id
    * @param servicingProviderKey string representing the servicing provider key
    * @returns an AdequacyCriticality object containing the provider criticality score.
  */
  public async getAdequacyCriticality(projectRunConfigurationId: number, servicingProviderKey: string): Promise<AdequacyCriticality> {
    return await this.makeGet<AdequacyCriticality>(`${this.endpoint}/adequacy/project-run-configurations/${projectRunConfigurationId}/servicing-providers/${servicingProviderKey}`);
  }

  /**
    * @param projectRunConfigurationId integer representing the project run configuration id
    * @param accessPointId integer representing the access point id
    * @returns a MarketAlternative object containing the market alternatives with their provider criticality scores.
  */
  public async getMarketAlternatives(projectRunConfigurationId: number, accessPointId: number): Promise<MarketAlternative[]> {
    return await this.makeGet<MarketAlternative[]>(`${this.endpoint}/adequacy/project-run-configurations/${projectRunConfigurationId}/access-points/${accessPointId}/top-alternatives`);
  }
};
